"use strict";
var editor_2d = require("editor-2d");
var lib_core = require("lib-core");
var HandleView = require("./../../../interactionViews/handleView.js");

var drawLineDataTo2D = require("./../../../view/renderData/drawLineDataTo2D.js");

var LineInteractionView = function (editorView, interactionModel, parentGroup, layers) {
    var self = this;
    this.editorView = editorView;
    this.gui = this.editorView;
    this.interactionModel = interactionModel;
    this.data = interactionModel.data;

    this.cameraModel = this.editorView.editorModel.cameraModel();

    this.initGroups(parentGroup, [layers.draw, layers.control]);

    this.elementSvgGroup = this.getGroupInfo(layers.draw).svgGroup;
    this.controlGroup = this.getGroupInfo(layers.control).svgGroup;

    $(this.controlGroup).mousedown(function (event) {
        var cEvent = self.getMouseDownEvent(event);
        return self.gui.stateMachine.handle(cEvent);
    });

    // follows 3-handle functionality
    this.handles = [];
    var threeHandles = this.handles;
    if (this.interactionModel.handles && layers.interaction) {
        this.interactionModel.handles.toArray().forEach(function (obj, idx) {
            threeHandles.push(new HandleView(self, editorView, idx, obj, parentGroup, layers));
        });
    }

    if (this.interactionModel) {
        this.interactionModel.selected.onChange(this, function (value) {
            self.setSelected(value);
        }, 10);
    }

    this.data.onBubble(this, function () {
        self.editorView.heavyHandler.scheduleHeavy('rebuild_view', self.draw, self, [], self);
    }, 10);

    this.cameraModel.viewS.onChange(self, function () {
        self.editorView.heavyHandler.scheduleHeavy('resize_control', self.resizeControl, self, [], self);
    }, 10);

    this.draw();
};
lib_core.mixin(LineInteractionView, editor_2d.DrawingElement);

module.exports = LineInteractionView;

LineInteractionView.prototype.draw = function () {
    var self = this;

    $(this.elementSvgGroup).empty();
    $(this.controlGroup).empty();
    if (!this.data.isAlive()) return;

    // draw visible
    drawLineDataTo2D(this.editorView.svg, this.elementSvgGroup, this.data);

    // draw control
    drawLineDataTo2D(this.editorView.svg, this.controlGroup, this.data);

    this.control = $(":nth-last-child(1)", this.controlGroup);
    this.resizeControl();
};

LineInteractionView.prototype.resizeControl = function (event) {
    if(this.control) this.control.attr("stroke-width", this.data.strokeWidth() + 4 / this.cameraModel.viewS());
};

LineInteractionView.prototype.getMouseDownEvent = function (event) {
    var cEvent = new lib_core.GuiEvent(lib_core.GuiEvents.ELEMENT_MOUSE_DOWN)
        .fromJSEvent(event)
        .element(this.interactionModel)
        .data('mouseCoord', this.editorView.relativeMouseCoord(event));

    return cEvent;
};
